import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";

import { VendorAuthProvider } from "./vendor/store/vendorAuthStore";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter basename="/yuroshopy/vendor">  {/* ✅ Fixed for cPanel subdirectory */}
      <VendorAuthProvider>
        <App />
      </VendorAuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);